/* ZGD · Hace rotar las reseñas de Revie
   Problema: el carrusel de Revie trae las 10 reseñas pero siempre arranca en la
   misma, así que parecía que llevaban meses sin cambiar.
   Solución: se mezcla el orden en cada visita y se avanza solo cada 6 segundos.
   Si Revie cambia su widget, esto no rompe nada: simplemente no hace nada. */
(function () {
  'use strict';
  var LISTA = '.carouselPre';
  var CICLO = 6000;
  var lento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function mezcla(lista) {
    var hijos = Array.prototype.slice.call(lista.children);
    if (hijos.length < 3) return false;
    for (var i = hijos.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      lista.appendChild(hijos[j]);
      hijos.splice(j, 1);
    }
    return true;
  }

  function flechaSiguiente(raiz) {
    var botones = raiz.parentNode
      ? raiz.parentNode.querySelectorAll('button,[role="button"],a')
      : [];
    for (var i = 0; i < botones.length; i++) {
      var t = (botones[i].textContent || '') + (botones[i].getAttribute('aria-label') || '');
      if (/❯|›|>|next|siguiente/i.test(t)) return botones[i];
    }
    return null;
  }

  function arranca(lista) {
    if (!mezcla(lista)) return;
    if (lento) return;
    var flecha = flechaSiguiente(lista);
    if (!flecha) return;
    var timer = setInterval(function () {
      if (document.hidden) return;
      flecha.click();
    }, CICLO);
    // al pasar el mouse se detiene, para poder leer
    var caja = lista.parentNode || lista;
    caja.addEventListener('mouseenter', function () { clearInterval(timer); });
  }

  var intentos = 0;
  var busca = setInterval(function () {
    var lista = document.querySelector(LISTA);
    if (lista && lista.children.length > 2) {
      clearInterval(busca);
      arranca(lista);
    } else if (++intentos > 40) {
      clearInterval(busca); // Revie no cargó: se deja como estaba
    }
  }, 400);
})();
